export default "__VITE_ASSET__$etJqGvg__"